import { ThemeSelectors } from "@at/design-system-foundation";
import { BREAKPOINTS } from "@at/window-utils";
import styled, { css } from "styled-components";

import { PrintStyleSheet } from "../../seller/advert-seller-details/location/location.styles";

export const GalleryMediaTabsStyles = styled.div`
  display: flex;
  position: absolute;
  left: 0;
  right: 0;
  top: 78px;
  width: 100%;
  background-color: ${({ theme }) => ThemeSelectors.getWhite(theme)};
  justify-content: center;
  align-items: center;
  padding: 0 ${({ theme }) => ThemeSelectors.getRelatedTwoSpacing(theme)} 16px
    ${({ theme }) => ThemeSelectors.getRelatedTwoSpacing(theme)};

  @media screen and (min-width: ${BREAKPOINTS.MEDIUM}px) {
    position: initial;
  }

  ${PrintStyleSheet}

  .atds-toggle {
    background-color: transparent;
    border-radius: 0;
    box-shadow: none;
    color: ${({ theme }) => ThemeSelectors.getTitleColor(theme)};
    @media (orientation: landscape) and (hover: none) and (pointer: coarse) and (max-width: 900px) {
      width: 100%;
    }
    &__item {
      min-width: 100px;
    }
  }

  .atds-toggle__label {
    padding: ${({ theme }) => ThemeSelectors.getGridUnit(theme)}
      ${({ theme }) => `calc(${ThemeSelectors.getGridUnit(theme)} * 3) `};
  }

  .atds-toggle__input:checked + label,
  .atds-toggle__item--selected {
    background-color: transparent;
    border-radius: 0;
    box-shadow: none;
    border-bottom: 2px solid
      ${({ theme }) => ThemeSelectors.getActionColor(theme)};
    color: ${({ theme }) => ThemeSelectors.getActionColor(theme)};
    font-weight: 600;
    font-variation-settings: "wght" 600;
  }

  .atds-toggle__item:not(:last-child) {
    box-shadow: none;
  }
`;

export const GalleryIFrameWrapper = styled.div`
  display: block;
  width: 100%;
  height: calc(100vh - 150px);
  overflow: hidden;
  position: relative;
  @media (orientation: landscape) and (hover: none) and (pointer: coarse) and (max-width: 900px) {
    height: calc(100vh - 85px);
  }

  > div {
    bottom: 15%;
    @media (max-width: 1124px) {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      margin: auto;
    }
    @media (orientation: landscape) and (hover: none) and (pointer: coarse) and (max-width: 900px) {
      position: relative;
    }
    @media (min-width: 768px) {
      bottom: 0;
    }
    @media (min-width: 1124px) {
      bottom: unset;
    }
  }

  iframe {
    @media (orientation: landscape) and (hover: none) and (pointer: coarse) and (max-width: 900px) {
      margin: 0 auto !important;
      width: 70% !important;
      height: 300px !important;
    }
    @media (min-width: 1124px) {
      margin: 0 auto !important;
    }
  }
`;

const iFrameElementStyle = () => css`
  iframe {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    margin: auto;
  }
`;

const iFrameContainerBaseStyle = () => css`
  display: block;
  position: relative;
  z-index: 0;
  box-sizing: content-box;
  height: 0;
  overflow: hidden;
`;

const iFrameVideoContainer = styled.div`
  ${iFrameContainerBaseStyle}
  padding-top: calc((9 / 16) * 100%);
  ${iFrameElementStyle}
`;

const iFrameSpinContainer = styled.div`
  ${iFrameContainerBaseStyle}
  padding-top: calc((88 / 117) * 100%);
  ${iFrameElementStyle}
`;
export const SpinContainer = styled(iFrameSpinContainer)``;

export const VideoContainer = styled(iFrameVideoContainer)``;
